import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IcNoti from '../../assets/image/ic_notice_gray_circle.svg';

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#363636',
    color: '#FFFFFF',
    maxWidth: 300,
    fontSize: '14px',
    padding: '14px',
    borderRadius: '10px',
  },
}));

interface ToolTipProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
}

export default function ToolTip({ open, setOpen, text }: ToolTipProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div style={{ display: 'inline-block' }}>
        <HtmlTooltip
          open={open}
          onClose={() => setOpen(false)}
          disableHoverListener
          disableFocusListener
          title={
            <div className="text-[14px] font-[400]">
              {text?.split('\n')?.map((str, idx) => {
                return <div key={idx}>{str.trim() ? str : <br />}</div>;
              }) || ''}
            </div>
          }
        >
          <img src={IcNoti} className="w-[18px] h-[18px] shrink-0" onClick={handleClick} alt="notification" />
        </HtmlTooltip>
      </div>
    </ClickAwayListener>
  );
}

